import React, { useState, useEffect } from "react";
import { Row, Col, Descriptions, Divider, Tag, Button } from 'antd';
import moment from "moment";
import Moment from "react-moment";
import { PrinterFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CrDisplay = function CrDisplay(_ref) {
  var _ref$check = _ref.check,
    check = _ref$check === void 0 ? null : _ref$check;
  var PrintElem = function PrintElem(elem) {
    var mywindow = window.open('', 'PRINT', 'height=auto,width=auto');
    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('<link rel="stylesheet" href="css/app.css" type="text/css" />');
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById(elem).innerHTML);
    mywindow.document.write('</body></html>');
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();
    return true;
  };
  var customer = check != null ? check.customer : null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
      type: "primary",
      size: "large",
      onClick: function onClick() {
        PrintElem('prt');
      },
      icon: /*#__PURE__*/_jsx(PrinterFill, {
        size: 26
      }),
      children: " Imprimer"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
      id: "prt",
      style: {
        padding: '28px'
      },
      children: /*#__PURE__*/_jsx(Row, {
        gutter: 16,
        children: /*#__PURE__*/_jsx(Col, {
          span: 18,
          children: /*#__PURE__*/_jsxs("div", {
            className: "cr-wrapper",
            children: [/*#__PURE__*/_jsxs(Row, {
              gutter: 16,
              children: [/*#__PURE__*/_jsx(Col, {
                className: "gutter-row",
                span: 4,
                children: /*#__PURE__*/_jsx("img", {
                  src: "/drawables/logo_sos.jpeg"
                })
              }), /*#__PURE__*/_jsx(Col, {
                className: "gutter-row",
                span: 10,
                children: /*#__PURE__*/_jsx("h4", {
                  style: {
                    textAlign: "center",
                    marginTop: '40px'
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "COMPTE RENDU MEDICAL"
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
              gutter: 16,
              children: /*#__PURE__*/_jsxs(Col, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: "cool-radius",
                  style: {
                    background: '#FCD013'
                  },
                  children: check && customer && /*#__PURE__*/_jsxs(Descriptions, {
                    column: 2,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      labelStyle: {
                        fontWeight: 'Bold'
                      },
                      span: 2,
                      contentStyle: {
                        fontWeight: 'Bold'
                      },
                      label: "ID PATIENT",
                      children: customer.idnumber
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Pr\xE9nom"
                      }),
                      children: customer.firstname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Nom"
                      }),
                      children: customer.lastname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Tel."
                      }),
                      children: customer.mobile.slice(3)
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Genre"
                      }),
                      children: customer.gender == 'F' ? "Femme" : "Homme"
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "D. Naissance"
                      }),
                      children: /*#__PURE__*/_jsx(Moment, {
                        format: "DD/MM/YYYY",
                        children: customer.birthdate
                      })
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Profession"
                      }),
                      children: customer.job
                    })]
                  })
                }), /*#__PURE__*/_jsx(Divider, {}), check && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsxs(Descriptions, {
                    column: 2,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "CONSTANTES"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Poids"
                      }),
                      children: check.customer.weight
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Tension"
                      }),
                      children: check.customer.ta
                    })]
                  }), /*#__PURE__*/_jsxs(Descriptions, {
                    column: 2,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "ANTECEDANTS"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Ophtalmologique"
                      }),
                      children: check.customer.ant_ophtalmo != '' && check.customer.ant_ophtalmo != null ? check.customer.ant_ophtalmo : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "M\xE9dical"
                      }),
                      children: check.customer.ant_medic != '' && check.customer.ant_medic != null ? check.customer.ant_medic : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Chirurgical"
                      }),
                      children: (check.customer.ant_chirurgie = !'' && check.customer.ant_chirurgie != null) ? check.customer.ant_chirurgie : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Autres"
                      }),
                      children: check.customer.ant_others != '' && check.customer.ant_others != null ? check.customer.ant_others : '--'
                    })]
                  }), /*#__PURE__*/_jsxs(Descriptions, {
                    column: 2,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "CONSULTATION"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Motif"
                      }),
                      children: check.reason
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Traitement anterieur"
                      }),
                      children: check.traitement_anterieur != '' && check.traitement_anterieur != null ? check.traitement_anterieur : "--"
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Evolution"
                      }),
                      children: check.evolution != '' && check.evolution != null ? check.evolution : '--'
                    })]
                  }), /*#__PURE__*/_jsxs(Descriptions, {
                    column: 3,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "OBSERVATION OEIL GAUCHE"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "AVSC"
                      }),
                      children: check.avsc_g != '' && check.avsc_g != null ? check.avsc_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "AVC"
                      }),
                      children: check.avc_g != '' && check.avc_g != null ? check.avc_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Annexes"
                      }),
                      children: check.annexes_g != '' && check.annexes_g != null ? check.annexes_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Segment"
                      }),
                      children: check.segment_g != '' && check.segment_g != null ? check.segment_g : "--"
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Corn\xE9e"
                      }),
                      children: check.cornee_g != '' && check.cornee_g != null ? check.cornee_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Chambre anterieure"
                      }),
                      children: check.chambre_anterieure_g != '' && check.chambre_anterieure_g != null ? check.chambre_anterieure_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Pupille"
                      }),
                      children: check.pupille_g != '' && check.pupille_g != null ? check.pupille_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Iris"
                      }),
                      children: check.iris_g != '' && check.iris_g != null ? check.iris_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Reflexe photomoteur"
                      }),
                      children: check.reflexe_photomoteur_g != '' && check.reflexe_photomoteur_g != null ? check.reflexe_photomoteur_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Cristallin"
                      }),
                      children: check.cristallin_g != '' && check.cristallin_g != null ? check.cristallin_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "PIO"
                      }),
                      children: check.rio_g != '' && check.rio_g != null ? check.rio_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Dilatation"
                      }),
                      children: check.dilatation_g != '' && check.dilatation_g != null ? check.dilatation_g : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "FO"
                      }),
                      children: check.fo_g != '' && check.fo_g != null ? check.fo_g : '--'
                    })]
                  }), /*#__PURE__*/_jsxs(Descriptions, {
                    column: 3,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "OBSERVATION OEIL DROIT"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "AVSC"
                      }),
                      children: check.avsc_d != '' && check.avsc_d != null ? check.avsc_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "AVC"
                      }),
                      children: check.avc_d != '' && check.avc_d != null ? check.avc_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Annexes"
                      }),
                      children: check.annexes_d != '' && check.annexes_d != null ? check.annexes_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Segment"
                      }),
                      children: check.segment_d != '' && check.segment_d != null ? check.segment_d : "--"
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Corn\xE9e"
                      }),
                      children: check.cornee_d != '' && check.cornee_d != null ? check.cornee_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Chambre anterieure"
                      }),
                      children: check.chambre_anterieure_d != '' && check.chambre_anterieure_d != null ? check.chambre_anterieure_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Pupille"
                      }),
                      children: check.pupille_d != '' && check.pupille_d != null ? check.pupille_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Iris"
                      }),
                      children: check.iris_d != '' && check.iris_d != null ? check.iris_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Reflexe photomoteur"
                      }),
                      children: check.reflexe_photomoteur_d != '' && check.reflexe_photomoteur_d != 'null' ? check.reflexe_photomoteur_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Cristallin"
                      }),
                      children: check.cristallin_d != '' && check.cristallin_d != null ? check.cristallin_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "PIO"
                      }),
                      children: check.rio_d != '' && check.rio_d != null ? check.rio_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Dilatation"
                      }),
                      children: check.dilatation_d != '' && check.dilatation_d != null ? check.dilatation_d : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "FO"
                      }),
                      children: check.fo_d != '' && check.fo_d != null ? check.fo_d : '--'
                    })]
                  }), /*#__PURE__*/_jsx(Descriptions, {
                    column: 2,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "PRESCRIPTIONS"
                    }),
                    children: check.bilan_prescrits.map(function (b) {
                      return /*#__PURE__*/_jsxs(Descriptions.Item, {
                        children: [/*#__PURE__*/_jsx(Tag, {
                          color: "red",
                          children: b.medical_item.department.label
                        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                          style: {
                            fontSize: '12px'
                          },
                          children: b.medical_item.label
                        })]
                      }, b.id);
                    })
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
                    column: 1,
                    borderdred: true,
                    title: /*#__PURE__*/_jsx("b", {
                      children: "CONCLUSION"
                    }),
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "DIAGNOSTIC"
                      }),
                      children: check.diagnostic != '' && check.diagnostic != null ? check.diagnostic : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "INDICATION"
                      }),
                      children: check.indication != '' && check.indication != null ? check.indication : '--'
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "CONDUITE A TENIR"
                      }),
                      children: check.conduite != '' && check.conduite != null ? check.conduite : '--'
                    })]
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Le Medecin"
                    }), /*#__PURE__*/_jsx("br", {}), check.user.firstname + " " + check.user.lastname]
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
                })]
              })
            })]
          })
        })
      })
    })]
  });
};
export default CrDisplay;